import React from 'react'
import Link from 'next/link'

interface ChallengeSpaceLinkToDashboardProps {
	space: any
}

const ChallengeSpaceLinkToDashboard = ({
	space,
}: ChallengeSpaceLinkToDashboardProps) => {
	return (
		<div className="bg-yellow-300 rounded-lg shadow">
			<h2 className="text-2xl mb-4 font-sans font-bold px-8 pt-8">
				Submit a challenge
			</h2>
			<p className="mb-4 px-8 text-lg">
				You&apos;re already logged in. Please go to your dashboard to submit a
				challenge for this challenge space
			</p>
			<div className="px-8 pb-8">
				<Link
					href="/account/challenge-spaces/[challengeSpaceId]?tab=challenges"
					as={`/account/challenge-spaces/${space.id}?tab=challenges`}
					passHref
				>
					<button className="bg-purple-900 hover:bg-purple-800 duration-300 transition-colors text-white my-2">
						Submit a challenge
					</button>
				</Link>
			</div>
		</div>
	)
}

export default ChallengeSpaceLinkToDashboard
